import { BaseAPI } from "@/api/base.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { CertificadoInclusaoRegistro } from "@/models/certificadoInclusaoRegistro";

import moment from "moment";

export class ValidaCertificadoAPI extends BaseAPI<any> {
  constructor() {
    super();
  }

  public validaCertificado(
    codigoValidador: string
  ): AxiosObservable<CertificadoInclusaoRegistro> {
    const url = `${this.apiUrl}/api/sit/certificado/validar-certificado`;
    return this.axios.get(`${url}/${codigoValidador}`);
  }
}
